// Notification
export const getNotificationData = notification =>
  notification && notification.list && notification.list.items
    ? notification.list.items
    : [];

export const getNotificationItemsID = notification =>
  notification && notification.list && notification.list.items
    ? notification.list.items.map(notification => notification.id)
    : null;

export const getNotificationLoading = notification =>
  notification && notification.list && notification.list.loading
    ? notification.list.loading
    : false;



// WEBPACK FOOTER //
// ./src/selectors/notification.js